var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8917 19.1568L28.3584 25.8235C28.1584 27.8635 27.9984 29.4235 24.3851 29.4235H7.61172C3.99839 29.4235 3.83839 27.8635 3.63839 25.8235L3.10505 19.1568C2.99839 18.0502 3.34505 17.0235 3.97172 16.2368C3.98505 16.2235 3.98505 16.2235 3.99839 16.2102C4.73172 15.3168 5.83839 14.7568 7.07839 14.7568H24.9184C26.1584 14.7568 27.2517 15.3168 27.9717 16.1835C27.9851 16.1968 27.9984 16.2102 27.9984 16.2235C28.6517 17.0102 29.0117 18.0368 28.8917 19.1568Z",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 15.3302V8.46354C4.66797 3.93021 5.8013 2.79688 10.3346 2.79688H12.028C13.7213 2.79688 14.108 3.30354 14.748 4.15687L16.4413 6.42354C16.868 6.98354 17.1213 7.33021 18.2546 7.33021H21.6546C26.188 7.33021 27.3213 8.46354 27.3213 12.9969V15.3835",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5742 22.7568H19.4276",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.7657fc01660d7d58c888850b5a240618.svg";
export { ForwardRef as ReactComponent };